/* eslint-disable @typescript-eslint/no-explicit-any -- TODO: Clean code !!! */
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./equipment-grid.component.html?ngResource";
import { Component, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import _ from 'lodash';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { PrimeNGConfig, FilterMatchMode } from 'primeng/api';
import { ObjectUtils } from 'primeng/utils';
import { ClipboardService } from 'ngx-clipboard';
import GroupsButtonService from '../../../components/base/GroupsButton/GroupsButtonService';
import { debounceTime, distinctUntilChanged, filter, from, fromEvent, map, mergeMap } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import GroupService from '../../../components/admin/groups/GroupService';
import EquipmentInfoService from '../../../components/base/infoServices/EquipmentInfoService';
import { getFileName } from 'Utils/files';
const DEFAULT_LATITUDE = 37;
const DEFAULT_LONGITUDE = -97;
const DEFAULT_ZOOM = 4;
const DEFAULT_ZOOM_LOCATION_CHANGE = 12;
let EquipmentGridComponent = class EquipmentGridComponent {
    ngxSmartModalService;
    config;
    clipboardService;
    equipmentInfoService;
    groupsButtonService;
    formBuilder;
    groupService;
    cdr;
    _source;
    _currentMapLocation = { lat: DEFAULT_LATITUDE, lng: DEFAULT_LONGITUDE };
    set source(value) {
        this._source = value;
        this.loading = false;
    }
    get source() {
        return this._source;
    }
    title;
    globalFilterFields = ['name', 'id'];
    columns;
    defaultColumns;
    options;
    selected;
    organizations;
    saveEquipment;
    clearTable;
    editEqClicked = new EventEmitter();
    deleteEqClicked = new EventEmitter();
    disableEventsEqClicked = new EventEmitter();
    openCameraClicked = new EventEmitter();
    addRcuClicked = new EventEmitter();
    editRcuClicked = new EventEmitter();
    syncRcuClicked = new EventEmitter();
    pcswitchRcuClicked = new EventEmitter();
    pccunitRcuClicked = new EventEmitter();
    deleteRcuClicked = new EventEmitter();
    refreshClicked = new EventEmitter();
    equipmentTableVC;
    menu;
    longitudeInput;
    latitudeInput;
    daGroups;
    orgGroups = [];
    show = true;
    selectedGroups = [];
    selectedOrgGroups = [];
    selectedColumns = [];
    first = 0;
    selectedItems;
    loading = false;
    selectedItem;
    contextItems;
    selectedRowItem;
    map;
    multiSortMeta = [
        { field: 'MAPPED_eq.org', order: 1 },
        { field: 'MAPPED_rcu.name', order: 1 },
        { field: 'name', order: 1 }
    ];
    multiSortMetaMultipleEdit = [
        { field: 'MAPPED_eq.org', order: 1 },
        { field: 'name', order: 1 }
    ];
    groups;
    selectedItemsColumns = [
        {
            field: 'name',
            header: 'Name',
            type: 'text'
        },
        {
            field: 'MAPPED_eq.org',
            header: 'Organization',
            type: 'text'
        },
        {
            field: 'MAPPED_rcu.org',
            header: "RCU's Org",
            type: 'text'
        },
        {
            field: 'groups',
            header: 'Groups',
            type: 'text'
        },
        {
            field: 'settings.latitude',
            header: 'Latitude',
            type: 'text'
        },
        {
            field: 'settings.longitude',
            header: 'Longitude',
            type: 'text'
        },
        {
            field: 'settings.timezone',
            header: 'Timezone',
            type: 'text'
        }
    ];
    mapOptions;
    overlays;
    latitude;
    longitude;
    multipleEditForm = new FormGroup({
        name: new FormControl('', [Validators.minLength(1)]),
        groups: new FormControl(''),
        latitude: new FormControl('', [
            Validators.pattern('\\-?\\d*\\.?\\d{1,15}'),
            Validators.min(-90), Validators.max(90)
        ]),
        longitude: new FormControl('', [
            Validators.pattern('\\-?\\d*\\.?\\d{1,15}'),
            Validators.min(-180), Validators.max(180)
        ]),
        timezone: new FormControl('', [Validators.minLength(1)]),
        organization: new FormControl(''),
    });
    groupTreeRootOptions = {
        readOnly: false
    };
    DEFAULT_LATITUDE = DEFAULT_LATITUDE;
    DEFAULT_LONGITUDE = DEFAULT_LONGITUDE;
    DEFAULT_ZOOM = DEFAULT_ZOOM;
    DEFAULT_ZOOM_LOCATION_CHANGE = DEFAULT_ZOOM_LOCATION_CHANGE;
    constructor(ngxSmartModalService, config, clipboardService, equipmentInfoService, groupsButtonService, formBuilder, groupService, cdr) {
        this.ngxSmartModalService = ngxSmartModalService;
        this.config = config;
        this.clipboardService = clipboardService;
        this.equipmentInfoService = equipmentInfoService;
        this.groupsButtonService = groupsButtonService;
        this.formBuilder = formBuilder;
        this.groupService = groupService;
        this.cdr = cdr;
    }
    ngOnInit() {
        this.loading = true;
        _.pull(this.config.filterMatchModeOptions.text, FilterMatchMode.NOT_CONTAINS);
        this.selectedColumns = this.defaultColumns || [];
        if (this.clearTable) {
            this.clearTable.subscribe(() => {
                if (this.equipmentTableVC) {
                    this.equipmentTableVC.clear();
                }
            });
        }
    }
    setupForm() {
        this.multipleEditForm = this.formBuilder.group({
            name: [''],
            groups: [''],
            latitude: [''],
            longitude: [''],
            timezone: [''],
            organization: ['']
        });
    }
    getGroups(org = this.multipleEditForm.get('organization').value) {
        this.groupService.getGroupByOrg(org)
            .then(({ body }) => {
            this.orgGroups = [body];
        });
    }
    onShow() {
        const adminContextMenu = [
            { label: `Equipment - ${this.selectedRowItem.name}`, disabled: true },
            { separator: true },
            {
                label: 'Edit',
                icon: 'fad fa-fw fa-pencil',
                command: () => {
                    if (!this.selectedItems?.length) {
                        this.selectedItems = [this.selectedRowItem];
                    }
                    this.openEditModal();
                }
            },
            {
                label: 'Disable events',
                icon: 'fad fa-fw fa-power-off',
                command: () => this.disableEventsEqClicked.emit(this.selectedItems?.length > 1 ?
                    this.selectedItems : [this.selectedRowItem])
            },
            {
                label: 'Open Camera',
                icon: 'fad fa-fw fa-video',
                visible: this.selectedRowItem.equipmentType === 'cameras',
                command: () => this.openCameraClicked.emit(this.selectedRowItem)
            },
            // { separator: true, visible: Boolean(this.selectedRowItem.MAPPED_rcu) },
            // {
            //   label: `RCU - ${this.selectedRowItem.MAPPED_rcu?.name}`,
            //   disabled: true,
            //   visible: Boolean(this.selectedRowItem.MAPPED_rcu),
            // },
            // {
            //   label: 'Sync',
            //   icon: 'fad fa-fw fa-cloud',
            //   visible: Boolean(this.selectedRowItem.MAPPED_rcu),
            //   command: () => this.syncRcuClicked.emit(this.selectedRowItem)
            // },
            // {
            //   label: 'Power Cycle Switch',
            //   icon: 'fad fa-fw fa-power-off',
            //   visible: Boolean(this.selectedRowItem.MAPPED_rcu),
            //   command: () => this.pcswitchRcuClicked.emit(this.selectedRowItem)
            // },
            // {
            //   label: 'Power Cycle Computing Unit',
            //   icon: 'fad fa-fw fa-power-off',
            //   visible: Boolean(this.selectedRowItem.MAPPED_rcu),
            //   command: () => this.pccunitRcuClicked.emit(this.selectedRowItem)
            // },
            // { separator: true },
            // { label: 'Organization', disabled: true },
            // {
            //   label: 'Copy equipment org id',
            //   icon: 'fad fa-fw fa-cloud',
            //   command: () => this.copyToClipboard(this.selectedRowItem.org)
            // },
            // {
            //   label: 'Copy rcu org id',
            //   visible: Boolean(this.selectedRowItem.MAPPED_rcu),
            //   icon: 'fad fa-fw fa-cloud',
            //   command: () => this.copyToClipboard(this.selectedRowItem.MAPPED_rcu.org)
            // }
        ];
        const nonAdminContextMenu = [
            { label: `Equipment - ${this.selectedRowItem.name}`, disabled: true },
            { separator: true },
            // {
            //   label: 'Add',
            //   icon: 'fad fa-fw fa-plus-circle',
            //   command: () => this.addEqClicked.emit(this.selectedRowItem)
            // },
            {
                label: 'Edit',
                icon: 'fad fa-fw fa-pencil',
                command: () => {
                    if (this.selectedItems?.length > 1) {
                        this.openEditModal();
                    }
                    else {
                        this.editEqClicked.emit(this.selectedRowItem);
                    }
                }
            },
            {
                label: 'Delete',
                icon: 'fad fa-fw fa-trash',
                command: () => this.selectedItems?.length > 1 ?
                    this.openDeleteMultipleModal() : this.deleteEqClicked.emit(this.selectedRowItem)
            },
            {
                label: 'Disable events',
                icon: 'fad fa-fw fa-power-off',
                command: () => this.disableEventsEqClicked.emit(this.selectedItems?.length > 1 ?
                    this.selectedItems : [this.selectedRowItem])
            },
            {
                label: 'Open Camera',
                icon: 'fad fa-fw fa-video',
                visible: this.selectedRowItem.equipmentType === 'cameras',
                command: () => this.openCameraClicked.emit(this.selectedRowItem)
            },
            // { separator: true },
            // { label: `RCU - ${this.selectedRowItem.MAPPED_rcu?.name}`, disabled: true },
            // {
            //   label: 'Add',
            //   icon: 'fad fa-fw fa-plus-circle',
            //   command: () => this.addRcuClicked.emit(this.selectedRowItem)
            // },
            // { label: 'Edit', icon: 'fad fa-fw fa-pencil', command: () => this.editRcuClicked.emit(this.selectedRowItem) },
            // { label: 'Sync', icon: 'fad fa-fw fa-cloud', command: () => this.syncRcuClicked.emit(this.selectedRowItem) },
            // {
            //   label: 'Power Cycle Switch',
            //   icon: 'fad fa-fw fa-power-off',
            //   command: () => this.pcswitchRcuClicked.emit(this.selectedRowItem)
            // },
            // {
            //   label: 'Power Cycle Computing Unit',
            //   icon: 'fad fa-fw fa-power-off',
            //   command: () => this.pccunitRcuClicked.emit(this.selectedRowItem)
            // },
            // {
            //   label: 'Delete',
            //   icon: 'fad fa-fw fa-trash',
            //   command: () => this.deleteRcuClicked.emit(this.selectedRowItem)
            // },
            // { separator: true },
            // { label: 'Organization', disabled: true },
            // {
            //   label: 'Copy equipment org id',
            //   icon: 'fad fa-fw fa-cloud',
            //   command: () => this.copyToClipboard(this.selectedRowItem.org)
            // },
            // {
            //   label: 'Copy rcu org id',
            //   icon: 'fad fa-fw fa-cloud',
            //   command: () => this.copyToClipboard(this.selectedRowItem.MAPPED_rcu.orgId)
            // }
        ];
        this.contextItems = this.options.userRole === 'admin' ? adminContextMenu : nonAdminContextMenu;
    }
    resolveFieldData = (data, field) => ObjectUtils.resolveFieldData(data, field) ? String(ObjectUtils.resolveFieldData(data, field)) : '';
    rowTracker = (_index, item) => item.id;
    clearSelection() {
        this.selectedItems = [];
    }
    openEditModal() {
        this.ngxSmartModalService.setModalData({
            selectedItems: this.selectedItems
        }, 'multipleEditEquipmentModal');
        this.appendModalToBody('multipleEditEquipmentModal');
        this.mapOptions = {
            center: { lat: this.DEFAULT_LATITUDE, lng: this.DEFAULT_LONGITUDE },
            // zoom: this.DEFAULT_ZOOM_LOCATION_CHANGE,
            gestureHandling: 'cooperative',
        };
        if (this.selectedItems.length === 1) {
            // fill the form
            _.forEach({
                name: 'name',
                org: 'org',
                groups: 'groups',
                latitude: 'settings.latitude',
                longitude: 'settings.longitude',
                timezone: 'settings.timezone',
            }, (path, key) => {
                this.multipleEditForm.get(key)?.setValue(_.get(this.selectedItems[0], path));
            });
            this.selectedOrgGroups = this.selectedItems[0].groups;
            const lat = Number(this.multipleEditForm.get('latitude').value);
            const lng = Number(this.multipleEditForm.get('longitude').value);
            this._currentMapLocation = { lat, lng };
        }
        else {
            // Pre-select org if the org is the same for all equipment
            const orgs = _.reduce(this.selectedItems, (acc, eq) => acc.add(eq.org), new Set());
            if (orgs.size === 1) {
                const [theOrg] = orgs.values();
                this.multipleEditForm.get('organization').setValue(theOrg);
                this.getGroups();
            }
        }
        this.overlays = [];
        const multiEqModal = this.ngxSmartModalService.getModal('multipleEditEquipmentModal');
        let modalInputSubscription;
        multiEqModal.onOpenFinished
            .subscribe(() => {
            modalInputSubscription = from([
                this.longitudeInput.nativeElement,
                this.latitudeInput.nativeElement
            ])
                .pipe(mergeMap(elem => fromEvent(elem, 'keyup')
                .pipe(map((event) => event.target.value), filter(res => res.length > 1), debounceTime(1000), distinctUntilChanged())))
                .subscribe(() => {
                this._currentMapLocation = {
                    lat: Number(this.multipleEditForm.get('latitude').value),
                    lng: Number(this.multipleEditForm.get('longitude').value)
                };
                this.changeLocation(this._currentMapLocation);
            });
        });
        multiEqModal.onAnyCloseEventFinished
            .subscribe(() => {
            if (modalInputSubscription) {
                modalInputSubscription.unsubscribe();
            }
        });
        multiEqModal.open();
    }
    // This makes modal appears on top of sidenav
    appendModalToBody(identifier) {
        const element = document.querySelector(`#${identifier}`);
        document.querySelector('body').appendChild(element);
    }
    openDeleteMultipleModal() {
        this.ngxSmartModalService.setModalData({
            selectedItems: this.selectedItems
        }, 'multipleDeleteEquipmentModal');
        this.appendModalToBody('multipleDeleteEquipmentModal');
        this.ngxSmartModalService.open('multipleDeleteEquipmentModal');
    }
    setMap(event) {
        this.map = event.map;
        this.changeLocation(this._currentMapLocation);
    }
    changeLocation(position) {
        if (!_.isNaN(position.lat) && position.lat !== 0 && !_.isNaN(position.lng) && position.lng !== 0) {
            const bounds = new google.maps.LatLngBounds();
            this.overlays = [];
            this.overlays.push(new google.maps.Marker({ position }));
            // ... extend bounds
            this.overlays.forEach((marker) => {
                bounds.extend(marker.getPosition());
            });
            google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
                this.map.setZoom(DEFAULT_ZOOM_LOCATION_CHANGE);
                // if (this.getZoom() !== DEFAULT_ZOOM_LOCATION_CHANGE) {
                //
                // }
            });
            this.map.fitBounds(bounds);
        }
    }
    closeEditModal() {
        this.ngxSmartModalService.close('multipleEditEquipmentModal');
    }
    rowSelected($event) {
        this.selectedRowItem = this.selectedItem;
        $event.originalEvent?.stopPropagation();
    }
    onColReorder($event) {
        localStorage.setItem('eqGridColumns', JSON.stringify($event?.columns));
    }
    async openGroupsModal($event, readOnly) {
        this.daGroups = [];
        const org = $event.org;
        if (org) {
            const { body: groups } = await this.groupService.getGroupByOrg(org.id || org);
            this.daGroups = [groups];
        }
        this.selectedGroups = $event.groups;
        this.ngxSmartModalService.setModalData({
            readOnly,
            selectedEq: $event
        }, 'groupsModal');
        this.appendModalToBody('groupsModal');
        this.ngxSmartModalService.open('groupsModal');
        this.cdr.detectChanges();
    }
    closeGroupsModal() {
        this.ngxSmartModalService.close('groupsModal');
    }
    expandAll() {
        this.groups.forEach((node) => {
            this.expandRecursive(node, true);
        });
    }
    collapseAll() {
        this.groups.forEach((node) => {
            this.expandRecursive(node, false);
        });
    }
    printGroups() {
        this.selectedGroups = this.groupsButtonService.rebuildSelectedGroups();
        this.multipleEditForm.markAsTouched();
    }
    expandRecursive(node, isExpand) {
        node.expanded = isExpand;
        if (node.children) {
            node.children.forEach((childNode) => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }
    /**
     * Called whenever a modal is closed to clear the model
     * This is needed because within the ngx-modal the form component is only initialized once ever
     *
     * @param {object} modal
     * @memberof EquipmentGridComponent
     */
    resetFormModel(modal) {
        const { identifier } = modal || {};
        this.ngxSmartModalService.resetModalData(identifier);
        if (identifier === 'multipleEditEquipmentModal') {
            this.multipleEditForm.reset();
        }
    }
    ngOnChanges(changes) {
        if (changes.columns) {
            this.selectedColumns = this.defaultColumns || [];
        }
        if (changes.organizations && this.organizations?.length === 1) {
            this.getGroups(this.organizations[0]);
        }
        if (changes.selected) {
            this.selectedItem = changes.selected.currentValue;
        }
    }
    isSelectedItem(item) {
        return this.selectedItem && this.selectedItem === item;
    }
    copyToClipboard(text) {
        this.clipboardService.copy(text);
    }
    async handleSaveMultipleEdit() {
        const name = this.multipleEditForm.get('name').value;
        const latitude = Number(this.multipleEditForm.get('latitude').value);
        const longitude = Number(this.multipleEditForm.get('longitude').value);
        const timezone = this.multipleEditForm.get('timezone').value;
        const org = this.multipleEditForm.get('organization').value;
        const updatedEquipmentFields = {
            ...this.selectedItems.length === 1 && name ? { name } : {},
            ...this.selectedGroups.length ? { groups: _.map(this.selectedGroups, 'id') } : {},
            ...latitude || longitude || timezone ? {
                settings: {
                    ..._.isNaN(latitude) ? {} : { latitude },
                    ..._.isNaN(longitude) ? {} : { longitude },
                    ...timezone ? { timezone } : {}
                }
            } : {},
            ...org ? { org } : {},
        };
        if (_.has(updatedEquipmentFields, 'settings')) {
            // since we will be updating settings, lets make sure we have the full equipment in state
            await this.equipmentInfoService.getFullEquipment(_.map(this.selectedItems, 'id'));
        }
        const errors = await this.saveEquipment(_.map(this.selectedItems, ({ id }) => {
            // There is a slight chance for the equipment settings in the table to be out of sync,
            // so get the equipment from app state
            const { settings } = this.equipmentInfoService.getEquipment(id);
            return _.merge({
                id,
                ..._.has(updatedEquipmentFields, 'settings') && { settings }
            }, updatedEquipmentFields);
        }));
        if (!errors?.length) {
            this.ngxSmartModalService.close('multipleEditEquipmentModal');
            this.clearSelection();
        }
    }
    handleMapClick(event) {
        this.multipleEditForm.get('latitude').setValue(event.latLng.lat());
        this.multipleEditForm.get('longitude').setValue(event.latLng.lng());
        this.changeLocation({ lat: event.latLng.lat(), lng: event.latLng.lng() });
    }
    refreshData() {
        this.source = [];
        this.loading = true;
        this.refreshClicked.emit();
    }
    exportCSV(options = {}) {
        this.equipmentTableVC.exportFilename = getFileName('equipment-management');
        this.equipmentTableVC.exportCSV(options);
    }
    static ctorParameters = () => [
        { type: NgxSmartModalService },
        { type: PrimeNGConfig },
        { type: ClipboardService },
        { type: EquipmentInfoService },
        { type: GroupsButtonService },
        { type: FormBuilder },
        { type: GroupService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        source: [{ type: Input }],
        title: [{ type: Input }],
        globalFilterFields: [{ type: Input }],
        columns: [{ type: Input }],
        defaultColumns: [{ type: Input }],
        options: [{ type: Input }],
        selected: [{ type: Input }],
        organizations: [{ type: Input }],
        saveEquipment: [{ type: Input }],
        clearTable: [{ type: Input }],
        editEqClicked: [{ type: Output }],
        deleteEqClicked: [{ type: Output }],
        disableEventsEqClicked: [{ type: Output }],
        openCameraClicked: [{ type: Output }],
        addRcuClicked: [{ type: Output }],
        editRcuClicked: [{ type: Output }],
        syncRcuClicked: [{ type: Output }],
        pcswitchRcuClicked: [{ type: Output }],
        pccunitRcuClicked: [{ type: Output }],
        deleteRcuClicked: [{ type: Output }],
        refreshClicked: [{ type: Output }],
        equipmentTableVC: [{ type: ViewChild, args: ['equipmentTable',] }],
        menu: [{ type: ViewChild, args: ['cm',] }],
        longitudeInput: [{ type: ViewChild, args: ['longitudeInput', { static: false },] }],
        latitudeInput: [{ type: ViewChild, args: ['latitudeInput', { static: false },] }]
    };
};
EquipmentGridComponent = __decorate([
    Component({
        selector: 'equipment-grid',
        template: __NG_CLI_RESOURCE__0,
    })
], EquipmentGridComponent);
export { EquipmentGridComponent };
